import { render, staticRenderFns } from "./SettingsTable.vue?vue&type=template&id=3ba07f04&scoped=true&"
import script from "./SettingsTable.vue?vue&type=script&lang=js&"
export * from "./SettingsTable.vue?vue&type=script&lang=js&"
import style0 from "./SettingsTable.vue?vue&type=style&index=0&id=3ba07f04&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ba07f04",
  null
  
)

export default component.exports